import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Section, type SectionVariant } from "./Section";

type StepKey = "discovery" | "design" | "setup" | "event";

const STEPS: StepKey[] = ["discovery", "design", "setup", "event"];

interface ProcessSectionProps {
  variant?: SectionVariant;
}

export function ProcessSection({ variant }: ProcessSectionProps = {}) {
  const { t } = useTranslation(["landing", "common"]);

  return (
    <Section
      id="process"
      variant={variant}
      eyebrow={t("common:eyebrow.process")}
      title={t("landing:process.title")}
      subtitle={t("landing:process.subtitle")}
    >
      <Grid container spacing={3}>
        {STEPS.map((step, index) => (
          <Grid key={step} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card sx={{ height: "100%", borderRadius: 4 }}>
              <CardContent sx={{ p: 3.5 }}>
                <Stack spacing={2}>
                  <Typography
                    variant="h3"
                    component="span"
                    sx={(theme) => ({
                      color: theme.palette.primary.main,
                      fontFamily: '"Playfair Display", serif',
                      fontWeight: 700,
                      lineHeight: 1,
                    })}
                  >
                    0{index + 1}
                  </Typography>
                  <Typography variant="h6">{t(`landing:process.steps.${step}.title`)}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t(`landing:process.steps.${step}.description`)}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
